import { EnvironmentProviders, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { Amplify, ResourcesConfig } from 'aws-amplify';
import { environment } from 'src/environments/environment';

function initAmplify(): void {
  const { userPoolId, userPoolWebClientId, identityPoolId, oauth } = environment.awsConfig.auth;

  const amplifyConfig: ResourcesConfig = {
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId: userPoolWebClientId,
        identityPoolId,
        loginWith: { oauth },
      },
    },
  };

  if (environment.awsConfig.analytics) {
    const { appId, region } = environment.awsConfig.analytics.AWSPinpoint;
    amplifyConfig.Analytics = { Pinpoint: { appId, region } };
  }

  Amplify.configure(amplifyConfig);
}

export function provideAmplify(): EnvironmentProviders {
  return makeEnvironmentProviders([provideAppInitializer(initAmplify)]);
}
